import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

import Profile from "./Components/Profile/Profile";
import EcommerceHeader from "./Components/Header/EcommerceHeader";
import EcommerceSidebar from "./Components/Header/EcommerceSidebar";
import EcommerceFooter from "./Components/Footer/EcommerceFooter";
import Checkout from "./Components/Pages/Checkout";
import OrderSuccess from "./Components/Pages/OrderSuccess";
import Home from "./Components/Home/Home";
import Shop from "./Components/Shop/Shop";
import Contact from "./Components/Pages/Contact";
import Deals from "./Components/Pages/Deals";
import Categories from "./Components/Pages/Categories";
import Trending from "./Components/Pages/Trending";
import NewArrivals from "./Components/Pages/NewArrivals";
import Cart from "./Components/Cart/Cart";
import ProductDetails from "./Components/Pages/ProductDetails";
import AdminProducts from "./Components/Pages/AdminProducts";
import Login from "./Components/Auth/Login";
import Signup from "./Components/Auth/SignUp";
import PrivateRoute from "./Components/Auth/PrivateRoute";
import Wishlist from "./Components/Pages/Wishlist";
import Orders from "./Components/Profile/Orders";
import ScrollToTop from "./Components/Common/ScrollToTop";
import "./app-layout.css";
import AdminDashboard from "./Admin/AdminDashboard";
import OrderDetails from "./Components/Profile/OrderDetails";
import ShippingPolicy from "./Components/Policy/ShippingPolicy";
import TermsConditions from "./Components/Policy/TermsCondition";
import PrivacyPolicy from "./Components/Policy/PrivacyPolicy";
import CustomMug from "./Components/Pages/CustomMug";
import CustomCushionPage from "./Components/Pages/CustomCushionPage";
function MainLayout() {
  return (
    <div className="app-shell">
      <header className="app-header-fixed">
        <EcommerceHeader />
      </header>

      <EcommerceSidebar />

      <main className="app-main">
        <div className="app-content">
          <Outlet />
        </div>
      </main>

      <footer className="app-footer">
        <EcommerceFooter />
      </footer>
    </div>
  );
}

function PlainLayout() {
  return (
    <div className="app-shell">
      <main className="app-main">
        <div className="app-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function AuthLayout() {
  return (
    <div className="app-shell auth-shell">
      <main className="auth-main">
        <div className="auth-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
       <Route element={<MainLayout />}>
          {/* === PUBLIC ROUTES === */}
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/new-arrivals" element={<NewArrivals />} />
          <Route path="/trending" element={<Trending />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/shippingPolicy" element={<ShippingPolicy />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termscondition" element={<TermsConditions />} />
          <Route path="/customize-cushion/:id" element={<CustomCushionPage />} />
          {/* Cart is now PUBLIC so guests can view their items! */}
          <Route path="/cart" element={<Cart />} /> 

          {/* === PRIVATE ROUTES === */}
          <Route
            path="/trackorder"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <PrivateRoute>
                <OrderDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-products"
            element={
              <PrivateRoute>
                <AdminProducts />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
        </Route>
{/* <Route path="/customize-mug" element={<CustomMug />} /> */}
        <Route element={<PlainLayout />}>
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route path="/order-success/:id" element={<OrderSuccess />} />
        </Route>

        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
